import r from "./td-longtail-vue-components275.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var s = function() {
  var t = this, a = t._self._c, e = t._self._setupProxy;
  return a("div", { staticClass: "offer-tile-variant" }, [e.mappedVariants.length > 0 ? a(e.VariantSelector, { staticClass: "offer-tile-variant__variant", attrs: { type: t.type, "hide-name": "", variants: e.mappedVariants }, on: { "select-variant": (i) => t.$emit("select-variant", i) } }) : t._e(), t.limit && t.limit < t.variants.length ? a("div", { staticClass: "offer-tile-variant__limit" }, [t._v(" + " + t._s(t.variants.length - t.limit) + " ")]) : t._e()], 1);
}, _ = [], l = /* @__PURE__ */ n(
  r,
  s,
  _,
  !1,
  null,
  "ed97e33f"
);
const c = l.exports;
export {
  c as default
};
